import React from 'react'
import { makeStyles, Theme } from '@material-ui/core/styles'
import { Grid, Box } from '@material-ui/core'
import Paper from '@material-ui/core/Paper'
import FormLabel from '@material-ui/core/FormLabel'
import LiquidSelectAdapter from '@src/components/LiquidSelectAdapter'
import { Formik, Field } from 'formik'
import Button from '@material-ui/core/Button'
import LiquidInputAdapter from '@src/components/LiquidInputAdapter'
import clsx from 'clsx'
import { configContext } from '../DnaPlates'
import messages from '../../../messages'
import { FormattedMessage, useIntl } from 'react-intl'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Checkbox from '@material-ui/core/Checkbox'
import {
  validateTextUpdated as validateText,
  convertToASCII,
} from '@src/routes/Configurators/utils/util'
import {
  useRuleValidateDuplexMutation,
  usePlateSessionFieldMutation,
} from '@src/mutations/ConfiguratorTubesMutation.generated'
import { useGetAntisenceSeqLazyQuery } from '@src/queries/ConfiguratorTubesQuery.generated'
import { EmptyResponse, emptyDuplexWellList, EmptyState } from '../Reducer'
import ValidationErrors from '../../../validations/ValidationErrors'
import { modificationTypeValueWithProperties } from '@src/routes/Configurators/components/OptionalModifications/ModificationResponse'
import DeleteAllDialog from '@src/routes/Configurators/components/DeleteDialog'
import { WarningKey, modificationNone, ActiveLinkTypeDnaplate } from '../enum'
import IconButton from '@material-ui/core/IconButton'
import ClearIcon from '@material-ui/icons/Clear'
import { ConfiguratorValues } from '@src/routes/Configurators/utils/constants'
import {
  formatSequence,
  sequenceCount,
} from '@src/routes/Configurators/utils/formatSequence'
import useDebounce from '@src/routes/Configurators/utils/ConfiguratorDebounce'
import { TubeProperties } from '../../../utils/enum'
import CircleLoader from '@src/components/CircleLoader'
import ValidationWarnings from '@src/routes/Configurators/validations/ValidationWarnings'
import styles from '@src/routes/Configurators/utils/styles'
import { useRouter, dnaPlatesRoute } from '@src/routes'
import { formatOverhangSequence } from '@src/routes/Configurators/utils/formatOverhangSequence'
import PreviewDisplay from './PreviewDisplay'
import { dropAllKeyInstances } from '@src/utils/ObjectHelpers/dropKeys'

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    flexGrow: 1,
  },
  headerPad: {
    paddingLeft: theme.spacing(6),
  },
  conainerSpacing: {
    paddingLeft: theme.spacing(8.5),
    paddingBottom: theme.spacing(6),
    paddingTop: theme.spacing(6),
  },
  conainerSpacingButtons: {
    paddingLeft: theme.spacing(9),
    paddingBottom: theme.spacing(8),
  },
  seqPad: {
    paddingTop: theme.spacing(6),
  },
  oligoPad: {
    paddingTop: theme.spacing(8),
    marginLeft: theme.spacing(12),
  },
  TextFontRes: {
    padding: theme.spacing(3.5),
    fontWeight: theme.typography.fontWeightMedium,
  },
  TextFontantisence: {
    padding: theme.spacing(3.5, 0, 3.5, 3.5),
    fontWeight: theme.typography.fontWeightMedium,
  },
  textAlign: {
    fontWeight: theme.typography.fontWeightMedium,
    padding: theme.spacing(3, 0, 2, 3),
  },
  textWidth: {
    width: theme.spacing(87),
  },
  textWidthSequence: {
    width: theme.spacing(87),
    padding: theme.spacing(1, 0, 0.5, 0),
  },
  sideHeadingMargin: {
    marginTop: theme.spacing(2.3),
  },
  AddModificationButton: {
    marginTop: theme.spacing(5),
    width: theme.spacing(50),
  },
  oligoMargin: {
    marginTop: theme.spacing(4),
    paddingTop: theme.spacing(2),
  },
  oligoName: {
    margin: theme.spacing(0, 0, 0, 3),
  },
  subheadColor: {
    color: '#1b1b25',
  },
  modificationsWidth: {
    width: theme.spacing(43),
  },
  modificationmargin: {
    marginLeft: theme.spacing(8.5),
  },
  sidemarginmodification: {
    marginTop: theme.spacing(7),
  },
  fontbase: {
    fontSize: theme.typography.pxToRem(13),
    fontWeight: theme.typography.fontWeightRegular,
  },
  over1: {
    fontSize: theme.typography.pxToRem(13),
    paddingLeft: theme.spacing(2),
    fontWeight: theme.typography.fontWeightRegular,
  },
  overrideCheckBox: {
    padding: theme.spacing(0),
  },
  autogeneratemargin: {
    margin: theme.spacing(0, 0, 3, 2),
  },
  sidemarginantisence: {
    marginTop: theme.spacing(11),
  },
  baseCountsenceMargin: {
    fontSize: theme.typography.pxToRem(13),
    margin: theme.spacing(0, 0, 2, 62),
    fontWeight: theme.typography.fontWeightRegular,
  },
  sidemarginsequence: {
    marginTop: theme.spacing(2),
  },
  warning: {
    padding: theme.spacing(0, 0, 0, 12),
  },
  overrideMargin: {
    marginLeft: theme.spacing(12),
  },
  override: {
    fontSize: theme.typography.pxToRem(14),
    color: '#1d5293',
    fontWeight: theme.typography.fontWeightMedium,
    paddingLeft: theme.spacing(2),
  },
  clearButton: {
    float: 'right',
    padding: theme.spacing(1),
  },
  closeIcon: {
    padding: theme.spacing(0, 4, 0, 0),
  },
  overrideroot: {
    marginRight: theme.spacing(0),
  },
  disableMod: {
    color: '#757575',
  },
  nameHelpText: {
    fontSize: theme.typography.pxToRem(10.8),
  },
  sequencehelpText: {
    paddingRight: theme.spacing(6),
  },
  fieldLabel: {
    '& label': {
      fontWeight: 'bold',
      minHeight: 12,
    },
  },
  topMarginAntisence: {
    marginTop: theme.spacing(2),
  },
}))

export interface DuplexProps {
  specificationsData: any
  well: any
  row: string
  col: string
  productDetails: any
  updatedData: any
}
const INITIAL_VALUES = {
  FiveModificationSelect: 'ALL',
  ThreeModificationSelect: 'ALL',
  oligoName: '',
}

export enum DefaultValue {
  Select = 'select',
  ThreeModification = 'threeMod',
  FiveModiFication = 'fiveMod',
  Overhang = 'overhang',
  Category = '',
  Sence = 'sence',
  Antisence = 'antisence',
}

const idGeneration = [
  { key: 'A', value: 0 },
  { key: 'B', value: 13 },
  { key: 'C', value: 25 },
  { key: 'D', value: 37 },
  { key: 'E', value: 49 },
  { key: 'F', value: 61 },
  { key: 'G', value: 73 },
  { key: 'H', value: 85 },
  { key: 'I', value: 97 },
  { key: 'J', value: 109 },
  { key: 'K', value: 121 },
  { key: 'L', value: 133 },
  { key: 'M', value: 145 },
  { key: 'N', value: 157 },
  { key: 'O', value: 169 },
  { key: 'P', value: 181 },
]
let insertSencePos = 0
let insertAntisencePos = 0
const DuplexWellDetails: React.FC<DuplexProps> = (props) => {
  const { specificationsData, well, row, col, productDetails, updatedData } =
    props
  const classes = useStyles()
  const GlobalCSS = styles()
  const router = useRouter()
  const [callDebounceCall, setCallDebounceCall] = React.useState(false)
  const [callDebounceAntisenceCall, setCallDebounceAntisenceCall] =
    React.useState(false)
  const [callDebounceName, setCallDebounceName] = React.useState(false)
  const [callDebounceAntisenceName, setCallDebounceAntisenceName] =
    React.useState(false)
  const [wellId, setWellId] = React.useState(0)
  const [sequence, setSequence] = React.useState('')
  const [baseCount, setBaseCount] = React.useState('0')
  const [oligoName, setOligoName] = React.useState('')
  const [threeModeValue, setThreeModeValue] = React.useState('')
  const [fiveModeValue, setFiveModeValue] = React.useState('')
  const [antisenceSequence, setAntisenceSequence] = React.useState('')
  const [antisencebaseCount, setAntisencebaseCount] = React.useState('0')
  const [senseNameCheck, setSenseNameCheck] = React.useState<boolean>(false)
  const [autoGenerateOligo, setAutoGenerateOligo] =
    React.useState<boolean>(false)
  const [antisenceOLigoName, setAntisenceOLigoName] = React.useState('')
  const [antisenceThreeModeValue, setAntisenceThreeModeValue] =
    React.useState('')
  const [antisenceFiveModeValue, setAntisenceFiveModeValue] = React.useState('')
  const [overhang, setOverhang] = React.useState('')
  const [antisenceOverhang, setAntisenceOverhang] = React.useState('')
  const { state, dispatch } = React.useContext(configContext)
  const { sessionData, currentPlateIndex, productInformation } = state
  const { instructions } = productInformation
  const [ruleValidateDuplex] = useRuleValidateDuplexMutation()
  const [nameValidation, setNameValidation] = React.useState<string[]>([])
  const [sequenceValidation, setSequenceValidation] = React.useState<string[]>(
    []
  )
  const [nameAntisenceValidation, setNameAntisenceValidation] = React.useState<
    string[]
  >([])
  const [sequenceAntisenceValidation, setSequenceAntisenceValidation] =
    React.useState<string[]>([])
  const [platesessionField] = usePlateSessionFieldMutation()
  const [getAntisenceSeq, { data }] = useGetAntisenceSeqLazyQuery()
  const [dialogOpen, setDialogOpen] = React.useState(false)
  const [duplexWarnings, setDuplexWarnings] = React.useState<string[]>([])
  const [isOverriden, setIsOverriden] = React.useState(false)
  const seqSenceInput: any = document.getElementById('sequence')
  const seqAntisenceInput: any = document.getElementById('Antisencesequence')
  const debouncedSequenceData = useDebounce(
    sequence,
    TubeProperties.SEQUENCE_API_TIME
  )

  const debouncedSequenceAntisenceData = useDebounce(
    antisenceSequence,
    TubeProperties.SEQUENCE_API_TIME
  )
  const debouncedName = useDebounce(oligoName, TubeProperties.SEQUENCE_API_TIME)
  const debouncedAntisenceName = useDebounce(
    antisenceOLigoName,
    TubeProperties.SEQUENCE_API_TIME
  )
  const [callRuleValidation, setCallRuleValidation] = React.useState(false)
  const ruleValidation = async (obj) => {
    const response = await ruleValidateDuplex({
      variables: { input: obj, productInput: productDetails },
    })
    const { data } = response
    if (data && !data.ruleValidateDuplex.serverError) {
      dispatch({
        type: 'SET_PAGE_ERROR',
        data: '',
      })
      dispatch({ type: 'UPDATE_ERROR_RESPONSE', data: data.ruleValidateDuplex })
    } else {
      dispatch({
        type: 'SET_PAGE_ERROR',
        data: ConfiguratorValues.InternalServerError,
      })
    }
  }

  const savePlateDataToSession = async (obj) => {
    await platesessionField({
      variables: { input: obj, productInput: productDetails },
    })
  }

  const getAntisence = async (obj) => {
    await getAntisenceSeq({
      variables: { seq: obj, product: productDetails },
    })
  }

  const [updateWellLoading, setUpdateWellLoading] = React.useState(false)
  const rulevalidateAndSave = async (wellClicked) => {
    setUpdateWellLoading(true)
    dispatch({ type: 'SET_MINIMUM_WELLS_ERROR', data: false })
    let error: any = []
    let warning: any = []
    const response = await ruleValidateDuplex({
      variables: { input: state.errorDataDuplex, productInput: productDetails },
    })
    const { data } = response
    if (data && !data.ruleValidateDuplex.serverError) {
      dispatch({
        type: 'SET_PAGE_ERROR',
        data: '',
      })
      dispatch({ type: 'UPDATE_ERROR_RESPONSE', data: data.ruleValidateDuplex })
      error = data.ruleValidateDuplex?.listErrors
      warning = data.ruleValidateDuplex?.listWarning
      let selectedWellId = wellClicked
      if (wellId === 0) {
        const well = Object.assign({}, emptyDuplexWellList)

        idGeneration.forEach((id) => {
          if (id.key === row) {
            well.id = id.value + parseInt(col, 10)
            setWellId(id.value + parseInt(col, 10))
            selectedWellId = id.value + parseInt(col, 10)
          }
        })
        well.countryCode = productDetails.countryCode
        well.productType = productDetails.productType
        well.row = row
        well.column = col
        sessionData[currentPlateIndex].biTubeWellList.push(well)
        sessionData[currentPlateIndex].countOfWells =
          sessionData[currentPlateIndex].biTubeWellList.length
      }
      sessionData[currentPlateIndex].biTubeWellList.forEach((wells) => {
        if (
          wells.row === row &&
          wells.column === col &&
          wells.id === selectedWellId
        ) {
          wells.name = oligoName
          wells.sequence = sequence
          wells.threeMod = threeModeValue
          wells.fiveMod = fiveModeValue
          wells.baseCount = data.ruleValidateDuplex.baseCount
            ? data.ruleValidateDuplex.baseCount
            : sequence.split(' ').join('').length
          wells.antisenceName = antisenceOLigoName
          wells.antisenceSequence = antisenceSequence
          wells.antisenceThreeMod = antisenceThreeModeValue
          wells.antisenceFiveMod = antisenceFiveModeValue
          wells.antisenceBaseCount = data.ruleValidateDuplex.antisenseBaseCount
            ? data.ruleValidateDuplex.antisenseBaseCount
            : antisenceSequence.split(' ').join('').length
          wells.customerOverhang = overhang
          wells.customerAntisenseOverHang = antisenceOverhang
          wells.senseNameCheck = senseNameCheck
          wells.autoGenerateOligo = autoGenerateOligo
          wells.isOverridden = isOverriden
          delete wells.__typename
          error.forEach((error) => {
            delete error.__typename
          })
          warning.forEach((warning) => {
            delete warning.__typename
          })
          wells.listError = error
          wells.listWarning = warning
          if (data?.ruleValidateDuplex?.molecularWeight) {
            wells.molecularWeight = data.ruleValidateDuplex.molecularWeight
          }
          if (data?.ruleValidateDuplex?.primerDimer) {
            wells.primerDimer = data.ruleValidateDuplex.primerDimer
          }
          if (data?.ruleValidateDuplex?.gcContent) {
            wells.gcContent = data.ruleValidateDuplex.gcContent
          }
          if (data?.ruleValidateDuplex?.meltingTemperature) {
            wells.meltingTemparature =
              data.ruleValidateDuplex.meltingTemperature
          }
          if (data?.ruleValidateDuplex?.secondaryStructure) {
            wells.secondaryStructure =
              data.ruleValidateDuplex.secondaryStructure
          }
          if (data?.ruleValidateDuplex?.antisenseMolecularWeight) {
            wells.antisenseMolecularWeight =
              data.ruleValidateDuplex.antisenseMolecularWeight
          }
          if (data?.ruleValidateDuplex?.antisensePrimerDimer) {
            wells.antisensePrimerDimer =
              data.ruleValidateDuplex.antisensePrimerDimer
          }
          if (data?.ruleValidateDuplex?.antisenseGcContent) {
            wells.antisenseGcContent =
              data.ruleValidateDuplex.antisenseGcContent
          }
          if (data?.ruleValidateDuplex?.antisenseMeltingTemperature) {
            wells.antisenseMeltingTemparature =
              data.ruleValidateDuplex.antisenseMeltingTemperature
          }
          if (data?.ruleValidateDuplex?.antisenseSecondaryStructure) {
            wells.antisenseSecondaryStructure =
              data.ruleValidateDuplex.antisenseSecondaryStructure
          }
        }
      })
      sessionData.forEach((data) => {
        data.pageNo = 1
      })

      dispatch({
        type: 'UPDATE_INPUT',
        data: [...state.sessionData],
      })
      dispatch({ type: 'SET_STEP_NO', data: 1 })
      savePlateDataToSession(sessionData)
      setUpdateWellLoading(false)
      if (error.length === 0) {
        updatedData()
      }
    } else {
      dispatch({
        type: 'SET_PAGE_ERROR',
        data: ConfiguratorValues.InternalServerError,
      })
    }
  }

  React.useEffect(() => {
    setOligoName(well[0].name)
    setSequence(well[0].sequence)
    setBaseCount(well[0].baseCount.toString())
    setSenseNameCheck(well[0].senseNameCheck)
    setAntisenceOLigoName(well[0].antisenceName)
    setAntisenceSequence(well[0].antisenceSequence)
    setAntisencebaseCount(well[0].antisenceBaseCount.toString())
    setAutoGenerateOligo(well[0].autoGenerateOligo)
    setIsOverriden(well[0].isOverridden)
    setWellId(well[0].id)
    if (well[0].id === 0) {
      setThreeModeValue(modificationNone.none)
      setFiveModeValue(modificationNone.none)
      setAntisenceThreeModeValue(modificationNone.none)
      setAntisenceFiveModeValue(modificationNone.none)
      setOverhang(modificationNone.DuplexOverhang)
      setAntisenceOverhang(modificationNone.DuplexOverhang)
      setCallRuleValidation(false)
      dispatch({
        type: 'UPDATE_ERROR_RESPONSE',
        data: EmptyResponse,
      })
      dispatch({
        type: 'UPDATE_ERROR_DATA_DUPLEX',
        data: {
          ...state.errorDataDuplex,
          pageNo: 2,
          antisenceBaseCount: well[0].antisenceBaseCount,
          antisenceFiveMod: modificationNone.none,
          antisenceName: well[0].antisenceName,
          antisenceSequence: well[0].antisenceSequence,
          antisenceThreeMod: modificationNone.none,
          baseCount: well[0].baseCount,
          customerAntisenseOverHang: modificationNone.DuplexOverhang,
          customerOverhang: modificationNone.DuplexOverhang,
          fiveMod: modificationNone.none,
          isOverridden: well[0].isOverridden,
          name: well[0].name,
          sequence: well[0].sequence,
          threeMod: modificationNone.none,
          autoGenerateOligo: well[0].autoGenerateOligo,
        },
      })
    } else {
      setThreeModeValue(well[0].threeMod)
      setFiveModeValue(well[0].fiveMod)
      setAntisenceThreeModeValue(well[0].antisenceThreeMod)
      setAntisenceFiveModeValue(well[0].antisenceFiveMod)
      setOverhang(well[0].customerOverhang)
      setAntisenceOverhang(well[0].customerAntisenseOverHang)
      setCallRuleValidation(true)
      dispatch({
        type: 'UPDATE_ERROR_RESPONSE',
        data: {
          ...state.errorResponseJson,
          listErrors: well[0].listError,
          listWarning: well[0].listWarning,
          baseCount: well[0].baseCount,
          antisenseBaseCount: well[0].antisenceBaseCount,
        },
      })
      dispatch({
        type: 'UPDATE_ERROR_DATA_DUPLEX',
        data: {
          ...state.errorDataDuplex,
          pageNo: 2,
          antisenceBaseCount: well[0].antisenceBaseCount,
          antisenceFiveMod: well[0].antisenceFiveMod,
          antisenceName: well[0].antisenceName,
          antisenceSequence: well[0].antisenceSequence,
          antisenceThreeMod: well[0].antisenceThreeMod,
          baseCount: well[0].baseCount,
          customerAntisenseOverHang: well[0].customerAntisenseOverHang,
          customerOverhang: well[0].customerOverhang,
          fiveMod: well[0].fiveMod,
          isOverridden: well[0].isOverridden,
          name: well[0].name,
          sequence: well[0].sequence,
          threeMod: well[0].threeMod,
          autoGenerateOligo: well[0].autoGenerateOligo,
        },
      })
    }
    // TODO: need a test before we refactor these dependencies
  }, [well])

  React.useEffect(() => {
    if (callRuleValidation) {
      setCallRuleValidation(false)
      if (
        oligoName !== '' ||
        sequence !== '' ||
        antisenceOLigoName !== '' ||
        antisenceSequence !== '' ||
        wellId !== 0
      ) {
        ruleValidation(state.errorDataDuplex)
      } else {
        dispatch({
          type: 'UPDATE_ERROR_RESPONSE',
          data: EmptyResponse,
        })
      }
    }
    // TODO: need a test before we refactor these dependencies
  }, [state.errorDataDuplex])
  const intl = useIntl()
  const sequenceKey = messages.CONF_SEQUENCE_TEXT.defaultMessage
  const antisencesequenceKey = messages.CONF_ANTISENSE_SEQ_KEY.defaultMessage
  const nameKey = messages.CONF_OLIGO_NAME_KEY.defaultMessage

  const antisencenameKey = messages.CONF_ANTISENSE_NAME_KEY.defaultMessage
  const checkValidation = () => {
    const errorSequence: string[] = []
    setSequenceValidation([])
    const errorName: string[] = []
    setNameValidation([])
    const errorAntisenceSequence: string[] = []
    setSequenceAntisenceValidation([])
    const errorAntisenceName: string[] = []
    setNameAntisenceValidation([])
    const warnings: string[] = []
    setDuplexWarnings([])
    setBaseCount(state.errorResponseJson.baseCount.toString())
    setAntisencebaseCount(state.errorResponseJson.antisenseBaseCount.toString())
    if (state.errorResponseJson) {
      state.errorResponseJson.listWarning.forEach((warning) => {
        if (warning.key === WarningKey.antisencesequence_mismatch) {
          warnings.push(warning.value)
        }
        if (
          warning.key === WarningKey.name ||
          warning.key === WarningKey.antisenceName
        ) {
          warnings.push(intl.formatMessage(messages.CONF_OLIGO_NAME_WARNING))
        }
      })
      state.errorResponseJson.listErrors.forEach((obj) => {
        if (
          obj.key === sequenceKey ||
          obj.key === ConfiguratorValues.SequencePriority
        ) {
          errorSequence.push(obj.value)
          setBaseCount(' --')
        }
        if (obj.key === nameKey) {
          errorName.push(obj.value)
        }
        if (
          obj.key === antisencesequenceKey ||
          obj.key === ConfiguratorValues.antisencesequencePriority
        ) {
          errorAntisenceSequence.push(obj.value)
          setAntisencebaseCount(' --')
        }
        if (obj.key === antisencenameKey) {
          errorAntisenceName.push(obj.value)
        }
      })
    }
    setNameValidation(errorName)
    setSequenceValidation(errorSequence)
    setNameAntisenceValidation(errorAntisenceName)
    setSequenceAntisenceValidation(errorAntisenceSequence)
    setDuplexWarnings(warnings)
  }
  React.useEffect(() => {
    checkValidation()
    // TODO: need a test before we refactor these dependencies
  }, [state.errorResponseJson])

  React.useEffect(() => {
    if (seqAntisenceInput) {
      seqAntisenceInput.selectionEnd = insertAntisencePos
    }
    // TODO: need a test before we refactor these dependencies
  }, [antisenceSequence])

  React.useEffect(
    () => {
      if (callDebounceAntisenceCall) {
        setCallDebounceAntisenceCall(false)
        dispatch({
          type: 'UPDATE_ERROR_DATA_DUPLEX',
          data: {
            ...state.errorDataDuplex,
            antisenceSequence: debouncedSequenceAntisenceData,
            antisenceBaseCount: debouncedSequenceAntisenceData.length,
          },
        })
      }
    },
    // TODO: need a test before we refactor these dependencies

    [debouncedSequenceAntisenceData]
  )

  React.useEffect(
    () => {
      if (callDebounceAntisenceName) {
        setCallDebounceAntisenceName(false)
        dispatch({
          type: 'UPDATE_ERROR_DATA_DUPLEX',
          data: {
            ...state.errorDataDuplex,
            antisenceName: debouncedAntisenceName,
          },
        })
      }
    },
    // TODO: need a test before we refactor these dependencies

    [debouncedAntisenceName]
  )

  React.useEffect(
    () => {
      if (callDebounceName) {
        setCallDebounceName(false)
        if (senseNameCheck) {
          dispatch({
            type: 'UPDATE_ERROR_DATA_DUPLEX',
            data: {
              ...state.errorDataDuplex,
              name: debouncedName,
              antisenceName: debouncedName + '_as',
            },
          })
        } else {
          dispatch({
            type: 'UPDATE_ERROR_DATA_DUPLEX',
            data: { ...state.errorDataDuplex, name: debouncedName },
          })
        }
      }
    },
    // TODO: need a test before we refactor these dependencies

    [debouncedName]
  )

  const handleName = (value, type) => {
    setCallRuleValidation(true)
    value = validateText(convertToASCII(value))
    if (type === DefaultValue.Sence) {
      setCallDebounceName(true)
      if (senseNameCheck) {
        setAntisenceOLigoName(value + '_as')
        setOligoName(value)
      } else {
        setOligoName(value)
      }
    } else {
      setCallDebounceAntisenceName(true)
      setAntisenceOLigoName(value)
    }
  }

  React.useEffect(() => {
    if (seqSenceInput) {
      seqSenceInput.selectionEnd = insertSencePos
    }
    // TODO: need a test before we refactor these dependencies
  }, [sequence])

  React.useEffect(
    () => {
      if (callDebounceCall) {
        setCallDebounceCall(false)
        if (autoGenerateOligo) {
          getAntisence(debouncedSequenceData)
        }
        dispatch({
          type: 'UPDATE_ERROR_DATA_DUPLEX',
          data: {
            ...state.errorDataDuplex,
            sequence: debouncedSequenceData,
            baseCount: debouncedSequenceData.length,
          },
        })
      }
    },
    // TODO: need a test before we refactor these dependencies

    [debouncedSequenceData]
  )

  const handleSequence = (value, type) => {
    setCallRuleValidation(true)
    value = validateText(convertToASCII(value))
    if (type === DefaultValue.Sence) {
      insertSencePos = seqSenceInput.selectionStart
      setBaseCount(sequenceCount(value).toString())
      setCallDebounceCall(true)
      setSequence(formatSequence(value))
    } else {
      insertAntisencePos = seqAntisenceInput.selectionStart
      setAntisencebaseCount(sequenceCount(value).toString())
      setCallDebounceAntisenceCall(true)
      setAntisenceSequence(formatSequence(value))
    }
  }

  const handleThreeMod = (value, type) => {
    setCallRuleValidation(true)
    if (type === DefaultValue.Sence) {
      setThreeModeValue(value)
      dispatch({
        type: 'UPDATE_ERROR_DATA_DUPLEX',
        data: { ...state.errorDataDuplex, threeMod: value },
      })
    } else {
      setAntisenceThreeModeValue(value)
      dispatch({
        type: 'UPDATE_ERROR_DATA_DUPLEX',
        data: { ...state.errorDataDuplex, antisenceThreeMod: value },
      })
    }
  }

  const handleAntisenseCheckbox = (value, type) => {
    setSenseNameCheck(value)
    if (value) {
      if (oligoName.length === 0) {
        handleName(oligoName, type)
      } else {
        handleName(oligoName + '_as', type)
      }
    }
  }

  const handleFiveMod = (value, type) => {
    setCallRuleValidation(true)
    if (type === DefaultValue.Sence) {
      setFiveModeValue(value)
      dispatch({
        type: 'UPDATE_ERROR_DATA_DUPLEX',
        data: { ...state.errorDataDuplex, fiveMod: value },
      })
    } else {
      setAntisenceFiveModeValue(value)
      dispatch({
        type: 'UPDATE_ERROR_DATA_DUPLEX',
        data: { ...state.errorDataDuplex, antisenceFiveMod: value },
      })
    }
  }
  const handleOverhang = (value, type) => {
    setCallRuleValidation(true)
    if (type === DefaultValue.Sence) {
      setOverhang(value)
      dispatch({
        type: 'UPDATE_ERROR_DATA_DUPLEX',
        data: { ...state.errorDataDuplex, customerOverhang: value },
      })
    } else {
      setAntisenceOverhang(value)
      dispatch({
        type: 'UPDATE_ERROR_DATA_DUPLEX',
        data: {
          ...state.errorDataDuplex,
          customerAntisenseOverHang: value,
        },
      })
    }
  }

  React.useEffect(() => {
    if (data !== undefined) {
      if (!data.getAntisenceSeq?.serverError) {
        if (
          data.getAntisenceSeq?.antisenceSeq !== null &&
          data.getAntisenceSeq?.antisenceSeq !== undefined
        ) {
          handleSequence(
            data.getAntisenceSeq?.antisenceSeq,
            DefaultValue.Antisence
          )
        }
      } else {
        dispatch({
          type: 'SET_PAGE_ERROR',
          data: ConfiguratorValues.InternalServerError,
        })
      }
    }
    // TODO: need a test before we refactor this
  }, [data])

  const handleAntisenseSequenceCheckbox = (value) => {
    setAutoGenerateOligo(value)
    dispatch({
      type: 'UPDATE_ERROR_DATA_DUPLEX',
      data: { ...state.errorDataDuplex, autoGenerateOligo: value },
    })
    if (value) {
      getAntisence(sequence)
    }
  }

  const handleOverride = (value) => {
    setCallRuleValidation(true)
    setIsOverriden(value)
    dispatch({
      type: 'UPDATE_ERROR_DATA_DUPLEX',
      data: { ...state.errorDataDuplex, isOverridden: value },
    })
  }

  const clearWell = () => {
    setDialogOpen(true)
  }
  const deleteItems = (item, type) => {
    dispatch({ type: 'SET_MINIMUM_WELLS_ERROR', data: false })
    if (type === 'SelectedWell') {
      sessionData[currentPlateIndex].biTubeWellList.forEach((item) => {
        if (item.row === row && item.column === col && item.id === wellId) {
          const index =
            sessionData[currentPlateIndex].biTubeWellList.indexOf(item)
          if (index !== -1) {
            sessionData[currentPlateIndex].biTubeWellList.splice(index, 1)
          }
        }
      })
      sessionData[currentPlateIndex].countOfWells =
        sessionData[currentPlateIndex].biTubeWellList.length
      if (
        sessionData[currentPlateIndex].biTubeWellList.length === 0 &&
        sessionData.length === 1
      ) {
        sessionData.splice(0, sessionData.length)
        state.sessionData.push(EmptyState)
        sessionData.forEach((data) => {
          // Drop __typename from the data object and then bind that return to the data on the loop.
          const dataRecast = dropAllKeyInstances(data, ['__typename'])
          data = dataRecast
        })
        dispatch({
          type: 'UPDATE_CURRENT_PLATE_INDEX',
          data: 0,
        })
        dispatch({
          type: 'UPDATE_INPUT',
          data: [...state.sessionData],
        })
        savePlateDataToSession([])
        dispatch({
          type: 'SET_STEP_NO',
          data: 0,
        })
        const url = `${dnaPlatesRoute.index()}?product=${
          productDetails.productType
        }&activeLink=${ActiveLinkTypeDnaplate.SequenceUpload}`
        router.push(url)
      } else {
        sessionData.forEach((data) => {
          data.pageNo = 1
        })
        dispatch({ type: 'SET_STEP_NO', data: 1 })
        dispatch({
          type: 'UPDATE_INPUT',
          data: [...state.sessionData],
        })
        savePlateDataToSession(sessionData)
      }
      setOligoName('')
      setSequence('')
      setThreeModeValue('')
      setFiveModeValue('')
      setSenseNameCheck(false)
      setAntisenceOLigoName('')
      setAntisenceSequence('')
      setAntisenceThreeModeValue('')
      setAntisenceFiveModeValue('')
      setOverhang('')
      setAntisenceOverhang('')
      setAutoGenerateOligo(false)
      setIsOverriden(false)
      setWellId(0)
      dispatch({
        type: 'UPDATE_ERROR_RESPONSE',
        data: EmptyResponse,
      })
    }
    updatedData()
  }
  const handleClose = () => {
    updatedData()
  }
  const renderMixedData = (modificationsResponseData) => {
    const result: any[] = []
    result.push(
      <div>
        <Box>
          <Grid container className={classes.conainerSpacing}>
            <Grid container>
              <Grid item xs={7}>
                <h2 className={classes.oligoName}>
                  <FormattedMessage {...messages.CONF_DUPLEX_SENSE_STRAD} />
                </h2>
              </Grid>
            </Grid>
            <Grid className={classes.seqPad} container spacing={4}>
              <Grid item xs={3} className={classes.sideHeadingMargin}>
                <FormLabel
                  className={clsx(classes.TextFontRes, classes.subheadColor)}
                >
                  <FormattedMessage
                    {...messages.CONF_DUPLEX_SENSE_OLIGO_NAME}
                  />
                </FormLabel>
              </Grid>
              <Grid item xs={8}>
                <Field
                  name="oligoName"
                  size="small"
                  fullWidth={false}
                  component={LiquidInputAdapter}
                  filled
                  className={classes.textWidth}
                  value={oligoName}
                  onChange={(e) => {
                    handleName(e.target.value, DefaultValue.Sence)
                  }}
                />
                <div
                  className={clsx(
                    classes.nameHelpText,
                    GlobalCSS.globalHelpTextColor
                  )}
                >
                  <FormattedMessage
                    {...messages.CONF_DNAPLATE_OLIGONAME_HELPTEXT}
                  />
                </div>
                <div>
                  <ValidationErrors errors={nameValidation} />
                </div>
              </Grid>
              <Grid item xs={3} className={classes.sidemarginsequence}>
                <FormLabel
                  className={clsx(classes.TextFontRes, classes.subheadColor)}
                >
                  <FormattedMessage
                    {...messages.CONF_DUPLEX_SENSE_OLIGO_SEQUENCE}
                  />
                </FormLabel>
              </Grid>
              <Grid item xs={8}>
                <Field
                  name="sequence"
                  size="small"
                  fullWidth={false}
                  component={LiquidInputAdapter}
                  filled
                  multiline
                  autoComplete="off"
                  className={clsx(classes.textWidthSequence)}
                  value={sequence}
                  onChange={(e) => {
                    handleSequence(e.target.value, DefaultValue.Sence)
                  }}
                />
                <Grid container>
                  <Grid
                    item
                    xs={8}
                    sm={8}
                    className={clsx(
                      classes.nameHelpText,
                      GlobalCSS.globalHelpTextColor,
                      GlobalCSS.sequenceBaseCountText,
                      classes.sequencehelpText
                    )}
                  >
                    <span>{instructions}</span>
                    <span>
                      <FormattedMessage {...messages.CONF_BASE_COUNT} />
                      {sequence.length !== 0 ? baseCount : ' --'}
                    </span>
                  </Grid>
                </Grid>
                <div>
                  <ValidationErrors errors={sequenceValidation} />
                </div>
              </Grid>
              <Grid item xs={3} className={classes.sidemarginmodification}>
                <FormLabel
                  className={clsx(
                    classes.TextFontRes,
                    sequence.length !== 0 && sequenceValidation.length === 0
                      ? classes.subheadColor
                      : classes.disableMod
                  )}
                >
                  <FormattedMessage
                    {...messages.CONF_DNAPLATES_MODIFICATIONS}
                  />
                </FormLabel>
              </Grid>
              <Grid item xs={2}>
                <Field
                  name="modificationTypeFiveMod"
                  component={LiquidSelectAdapter}
                  label="5'"
                  options={[
                    ...modificationTypeValueWithProperties(
                      DefaultValue.FiveModiFication,
                      DefaultValue.Category,
                      modificationsResponseData,
                      state.errorResponseJson.listFiveMod
                    ),
                  ]}
                  value={fiveModeValue}
                  onChange={(e) =>
                    handleFiveMod(e.target.value, DefaultValue.Sence)
                  }
                  filled
                  className={classes.modificationsWidth}
                  disabled={
                    sequence.length !== 0 && sequenceValidation.length === 0
                      ? false
                      : true
                  }
                />
              </Grid>
              <Grid item xs={5} className={classes.modificationmargin}>
                <Field
                  name="modificationTypeThreeMod"
                  component={LiquidSelectAdapter}
                  label="3'"
                  options={[
                    ...modificationTypeValueWithProperties(
                      DefaultValue.ThreeModification,
                      DefaultValue.Category,
                      modificationsResponseData,
                      state.errorResponseJson.listThreeMod
                    ),
                  ]}
                  value={threeModeValue}
                  onChange={(e) =>
                    handleThreeMod(e.target.value, DefaultValue.Sence)
                  }
                  filled
                  className={classes.modificationsWidth}
                  disabled={
                    sequence.length !== 0 && sequenceValidation.length === 0
                      ? false
                      : true
                  }
                />
              </Grid>
              <Grid item xs={3} className={classes.sideHeadingMargin}>
                <FormLabel
                  className={clsx(
                    classes.TextFontRes,
                    sequence.length !== 0 && sequenceValidation.length === 0
                      ? classes.subheadColor
                      : classes.disableMod
                  )}
                >
                  <FormattedMessage
                    {...messages.CONF_DUPLEX_SENSE_OLIGO_OVERHANG}
                  />
                </FormLabel>
              </Grid>
              <Grid item xs={8}>
                <Field
                  name="overhang"
                  component={LiquidSelectAdapter}
                  options={[
                    ...modificationTypeValueWithProperties(
                      DefaultValue.Overhang,
                      DefaultValue.Category,
                      modificationsResponseData,
                      state.errorResponseJson.listOverhang
                    ),
                  ]}
                  value={overhang}
                  onChange={(e) =>
                    handleOverhang(e.target.value, DefaultValue.Sence)
                  }
                  filled
                  className={classes.modificationsWidth}
                  disabled={
                    sequence.length !== 0 && sequenceValidation.length === 0
                      ? false
                      : true
                  }
                />
              </Grid>
            </Grid>
          </Grid>
        </Box>
        <Box>
          <Grid container className={classes.conainerSpacing}>
            <Grid container>
              <Grid item xs={7}>
                <h2 className={classes.oligoName}>
                  <FormattedMessage {...messages.CONF_DUPLEX_ANTISENSE_STRAD} />
                </h2>
              </Grid>
            </Grid>
            <Grid container spacing={4}>
              <Grid item xs={3} className={classes.sidemarginantisence}>
                <FormLabel
                  className={clsx(classes.TextFontRes, classes.subheadColor)}
                >
                  <FormattedMessage
                    {...messages.CONF_DUPLEX_ANTISENSE_OLIGO_NAME}
                  />
                </FormLabel>
              </Grid>
              <Grid item xs={8}>
                <div className={classes.autogeneratemargin}>
                  <FormControlLabel
                    classes={{
                      label: classes.over1,
                    }}
                    control={
                      <Checkbox
                        className={classes.overrideCheckBox}
                        color="primary"
                        value={senseNameCheck}
                        onChange={() => {
                          handleAntisenseCheckbox(
                            !senseNameCheck,
                            DefaultValue.Antisence
                          )
                        }}
                        checked={senseNameCheck}
                      />
                    }
                    label={
                      messages.CONF_DUPLEX_ANTISENSE_OLIGO_AUTOGENERATE
                        .defaultMessage
                    }
                  />
                </div>
                <Field
                  name="antisenceOligoName"
                  size="small"
                  fullWidth={false}
                  component={LiquidInputAdapter}
                  filled
                  className={classes.textWidth}
                  value={antisenceOLigoName}
                  disabled={senseNameCheck}
                  onChange={(e) => {
                    handleName(e.target.value, DefaultValue.Antisence)
                  }}
                />
                <div
                  className={clsx(
                    classes.nameHelpText,
                    GlobalCSS.globalHelpTextColor
                  )}
                >
                  <FormattedMessage
                    {...messages.CONF_DNAPLATE_OLIGONAME_HELPTEXT}
                  />
                </div>
                <div>
                  {senseNameCheck ? (
                    ''
                  ) : (
                    <ValidationErrors errors={nameAntisenceValidation} />
                  )}
                </div>
              </Grid>
              <Grid item xs={3} className={classes.sidemarginantisence}>
                <FormLabel
                  className={clsx(classes.TextFontRes, classes.subheadColor)}
                >
                  <FormattedMessage
                    {...messages.CONF_DUPLEX_ANTISENSE_OLIGO_SEQUENCE}
                  />
                </FormLabel>
              </Grid>
              <Grid item xs={8}>
                <div
                  className={clsx(classes.autogeneratemargin, classes.fontbase)}
                >
                  <FormControlLabel
                    classes={{
                      label: classes.over1,
                    }}
                    control={
                      <Checkbox
                        value={autoGenerateOligo}
                        color="primary"
                        onChange={() => {
                          handleAntisenseSequenceCheckbox(!autoGenerateOligo)
                        }}
                        checked={autoGenerateOligo}
                        className={classes.overrideCheckBox}
                      />
                    }
                    label={
                      messages.CONF_DUPLEX_ANTISENSE_SEQUENCE_AUTOGENERATE
                        .defaultMessage
                    }
                  />
                </div>
                <Field
                  name="Antisencesequence"
                  size="small"
                  fullWidth={false}
                  component={LiquidInputAdapter}
                  filled
                  multiline
                  autoComplete="off"
                  className={clsx(classes.textWidthSequence)}
                  value={
                    sequenceValidation.length !== 0 ? '' : antisenceSequence
                  }
                  disabled={
                    autoGenerateOligo || sequenceValidation.length !== 0
                  }
                  onChange={(e) => {
                    handleSequence(e.target.value, DefaultValue.Antisence)
                  }}
                />
                <Grid container>
                  <Grid
                    item
                    xs={8}
                    sm={8}
                    className={clsx(
                      classes.nameHelpText,
                      GlobalCSS.globalHelpTextColor,
                      GlobalCSS.sequenceBaseCountText,
                      classes.sequencehelpText
                    )}
                  >
                    <span>{instructions}</span>
                    <span>
                      <FormattedMessage {...messages.CONF_BASE_COUNT} />
                      {antisenceSequence.length !== 0
                        ? antisencebaseCount
                        : ' --'}
                    </span>
                  </Grid>
                </Grid>
                <div>
                  {autoGenerateOligo &&
                  sequenceAntisenceValidation.length === 0 ? (
                    ''
                  ) : (
                    <ValidationErrors errors={sequenceAntisenceValidation} />
                  )}
                </div>
              </Grid>
              <Grid item xs={3} className={classes.sidemarginmodification}>
                <FormLabel
                  className={clsx(
                    classes.TextFontantisence,
                    antisenceSequence.length !== 0 &&
                      sequenceAntisenceValidation.length === 0
                      ? classes.subheadColor
                      : classes.disableMod
                  )}
                >
                  <FormattedMessage
                    {...messages.CONF_DUPLEX_ANTISENSE_OLIGO_MODIFICATIONS}
                  />
                </FormLabel>
              </Grid>
              <Grid item xs={2}>
                <Field
                  name="AntisencemodificationTypeFiveMod"
                  component={LiquidSelectAdapter}
                  label="5'"
                  options={[
                    ...modificationTypeValueWithProperties(
                      DefaultValue.FiveModiFication,
                      DefaultValue.Category,
                      modificationsResponseData,
                      state.errorResponseJson.listFiveMod
                    ),
                  ]}
                  value={antisenceFiveModeValue}
                  onChange={(e) =>
                    handleFiveMod(e.target.value, DefaultValue.Antisence)
                  }
                  filled
                  className={classes.modificationsWidth}
                  disabled={
                    antisenceSequence.length !== 0 &&
                    sequenceAntisenceValidation.length === 0
                      ? false
                      : true
                  }
                />
              </Grid>
              <Grid item xs={5} className={classes.modificationmargin}>
                <Field
                  name="antisencemodificationTypeThreeMod"
                  component={LiquidSelectAdapter}
                  label="3'"
                  options={[
                    ...modificationTypeValueWithProperties(
                      DefaultValue.ThreeModification,
                      DefaultValue.Category,
                      modificationsResponseData,
                      state.errorResponseJson.listThreeMod
                    ),
                  ]}
                  value={antisenceThreeModeValue}
                  onChange={(e) =>
                    handleThreeMod(e.target.value, DefaultValue.Antisence)
                  }
                  filled
                  className={classes.modificationsWidth}
                  disabled={
                    antisenceSequence.length !== 0 &&
                    sequenceAntisenceValidation.length === 0
                      ? false
                      : true
                  }
                />
              </Grid>
              <Grid item xs={3} className={classes.sideHeadingMargin}>
                <FormLabel
                  className={clsx(
                    classes.TextFontRes,
                    antisenceSequence.length !== 0 &&
                      sequenceAntisenceValidation.length === 0
                      ? classes.subheadColor
                      : classes.disableMod
                  )}
                >
                  <FormattedMessage
                    {...messages.CONF_DUPLEX_ANTISENSE_OLIGO_OVERHANG}
                  />
                </FormLabel>
              </Grid>
              <Grid item xs={8}>
                <Field
                  name="antisenceOverhang"
                  component={LiquidSelectAdapter}
                  options={[
                    ...modificationTypeValueWithProperties(
                      DefaultValue.Overhang,
                      DefaultValue.Category,
                      modificationsResponseData,
                      state.errorResponseJson.listOverhang
                    ),
                  ]}
                  value={antisenceOverhang}
                  onChange={(e) =>
                    handleOverhang(e.target.value, DefaultValue.Antisence)
                  }
                  filled
                  className={classes.modificationsWidth}
                  disabled={
                    antisenceSequence.length !== 0 &&
                    sequenceAntisenceValidation.length === 0
                      ? false
                      : true
                  }
                />
              </Grid>
            </Grid>
          </Grid>
        </Box>
        <Box>
          <Grid container className={classes.conainerSpacing}>
            <Grid container>
              <Grid item xs={7}>
                <h2 className={classes.oligoName}>
                  <FormattedMessage
                    id="SEQUENCE_PREVIEW_DUPLEX"
                    defaultMessage="Sequence Preview"
                  />
                </h2>
              </Grid>
            </Grid>
            <Grid container spacing={4}>
              <PreviewDisplay
                labelId="SENSE_SEQUENCE_LABEL_DUPLEX"
                defaultMessage="Sense"
                sequence={sequence}
                sequenceValidation={sequenceValidation}
                fiveModeValue={fiveModeValue}
                threeModeValue={threeModeValue}
                overhang={overhang}
                formatOverhangSequence={formatOverhangSequence}
                modificationNone={modificationNone}
              />
              <PreviewDisplay
                labelId="ANTI_SENSE_SEQUENCE_LABEL_DUPLEX"
                defaultMessage="Antisense"
                sequence={antisenceSequence}
                sequenceValidation={sequenceAntisenceValidation}
                fiveModeValue={antisenceFiveModeValue}
                threeModeValue={antisenceThreeModeValue}
                overhang={antisenceOverhang}
                formatOverhangSequence={formatOverhangSequence}
                modificationNone={modificationNone}
                senseValidationError={sequenceValidation.length !== 0}
              />
            </Grid>
          </Grid>
        </Box>
      </div>
    )
    return result
  }
  return (
    <div className={classes.root}>
      <Box>
        <Formik
          initialValues={INITIAL_VALUES}
          onSubmit={(values, actions) => {
            setTimeout(() => {
              actions.setSubmitting(false)
            }, 1000)
          }}
        >
          {() => (
            <>
              <div>
                <Paper className={classes.oligoMargin}>
                  <Grid className={classes.closeIcon}>
                    <IconButton
                      className={classes.clearButton}
                      color="primary"
                      onClick={handleClose}
                    >
                      <ClearIcon fontSize="inherit" />
                    </IconButton>
                  </Grid>
                  <Grid container>
                    <Grid item xs={9}>
                      <h2 className={classes.headerPad}>
                        <FormattedMessage
                          {...messages.CONF_DNAPLATES_SELECTED_WELL}
                        />{' '}
                        {row}
                        {col}
                      </h2>
                    </Grid>
                    <Grid item xs={3}>
                      <div className={classes.overrideMargin}>
                        {productDetails.isCSRSupervisor === true ? (
                          <FormControlLabel
                            classes={{
                              label: classes.override,
                              root: classes.overrideroot,
                            }}
                            control={
                              <Checkbox
                                value={isOverriden}
                                color="primary"
                                checked={isOverriden}
                                onChange={() => {
                                  handleOverride(!isOverriden)
                                }}
                                className={classes.overrideCheckBox}
                              />
                            }
                            label={
                              messages.CONF_OVERRIDE_VALIDATION.defaultMessage
                            }
                          />
                        ) : (
                          ''
                        )}
                      </div>
                    </Grid>
                  </Grid>
                  <div className={GlobalCSS.plateWarningBox}>
                    <ValidationWarnings warnings={duplexWarnings} />
                  </div>
                  {renderMixedData(specificationsData)}
                  <Grid container className={classes.conainerSpacingButtons}>
                    <Grid item xs={3}>
                      <Button
                        color="primary"
                        variant="contained"
                        size="large"
                        onClick={() => rulevalidateAndSave(wellId)}
                        className={classes.AddModificationButton}
                      >
                        <FormattedMessage
                          {...messages.CONF_DNAPLATES_UPDATE_WELL}
                        />
                      </Button>
                    </Grid>
                    <Grid item xs={3}>
                      <Button
                        color="primary"
                        variant="contained"
                        size="large"
                        className={classes.AddModificationButton}
                        onClick={clearWell}
                      >
                        <FormattedMessage
                          {...messages.CONF_DNAPLATES_CLEAR_WELL}
                        />
                      </Button>
                    </Grid>
                  </Grid>
                  {updateWellLoading && <CircleLoader />}
                </Paper>
              </div>
            </>
          )}
        </Formik>
      </Box>
      <DeleteAllDialog
        dialogOpen={dialogOpen}
        setDialogOpen={setDialogOpen}
        type="SelectedWell"
        selectedItem={well}
        onDelete={deleteItems}
      />
    </div>
  )
}

export default DuplexWellDetails
